import axios from 'axios';

const base_url = process.env.REACT_APP_HOST_API_KEY;

const header = 'Bearer ' + localStorage.getItem("token")





export function get(url, isHeader = 1){

    if(isHeader === 1){
      return axios.get(base_url + url, { 
        headers: {
        'Authorization': `${header}`
        }
      })
      .catch(error => console.log(error))
      .finally(function () {
          // always executed
        });
    }  
    else if(isHeader === 0)  {
      return axios.get(base_url + url)
      .catch(error => console.log(error))
      .finally(function () {
          // always executed
        });
    }
}



export function post(url, request, isHeader = 1){
  if(isHeader === 1){
    return axios.post(base_url + url, request, { 
      headers: {
      'Authorization': `${header}`
      }
    })
    .catch(error => console.log(error))
    .finally(function () {
      // always executed
    });
  }
  else if(isHeader === 0){
    return axios.post(base_url + url, request)
    .catch(error => console.log(error))
    .finally(function () {
      // always executed
    });
  }
}


